import SubmitButton from './SubmitButton.js';
import AddButton from './AddButton.js';
import { CopyButton, MoveDownButton, MoveUpButton, RemoveButton, ClearButton } from './IconButton.js';
function buttonTemplates() {
    return {
        SubmitButton,
        AddButton,
        CopyButton,
        MoveDownButton,
        MoveUpButton,
        RemoveButton,
        ClearButton,
    };
}
export default buttonTemplates;
